import type { DSNCDealMSRP } from 'shared-definitions/types'
import type { ApiClearBuyProductMSRPProps } from 'data-source/types.wp'

export function ncProductMSRPMapper(input: ApiClearBuyProductMSRPProps): DSNCDealMSRP | null {
  if (!input.msrp || !input.msrp_currency) {
    return null
  }
  return {
    price: input.msrp,
    currency: input.msrp_currency,
  }
}
